import { useCallback } from 'react';
import { useSnowplowTracker } from '@mindtickle/snowplow-client';

import { useFullstoryHelpers } from '~/components/Fullstory';

import { APP_NAME, PROJECT_TYPE, STREAM_NAME } from '../config/constants';
import useBaseContexts from './useSnowplowContexts';
import { useUserAuth } from '~/components/Auth';
import { getDeviceType } from '../utils';

const eventDetails = {
  label: APP_NAME,
};
const staticProperties = {
  project_type: PROJECT_TYPE,
  stream: STREAM_NAME,
};

const useTrackerUtil = (label, tracker) => {
  const fullstoryHelpers = useFullstoryHelpers();
  const { learnerRoles, email } = useUserAuth();

  return useCallback(
    // eslint-disable-next-line max-params
    (action, properties = {}, value, extraContexts = []) =>
      tracker.trackStructuredEvent(
        action,
        {
          properties: {
            'FullStory Session': fullstoryHelpers.getCurrentUrl(),
            ...staticProperties,
            ...properties,
            dispatchTo: ['mixpanel'],
            admin_roles: learnerRoles,
            isMindtickleUser: email.indexOf('mindtickle.com') > -1,
            device_type: getDeviceType(),
          },
          value,
          ...eventDetails,
          label,
        },
        extraContexts
      ),
    [tracker, fullstoryHelpers, label]
  );
};

const useTracker = (label = APP_NAME, extraContexts = []) => {
  const selectedContexts = useBaseContexts();
  // no sidebar specific context
  const trackerWithContext = useSnowplowTracker([...selectedContexts, ...extraContexts]);
  const trackerFunc = useTrackerUtil(label, trackerWithContext);
  return trackerFunc;
};

export default useTracker;
